import { useState } from 'react';
import { clsx } from 'clsx';
import {
  DashboardDrawer,
  DashboardView,
  InspectionListView,
  NavbarPage,
  InspectionLinkCreateView,
} from '../../components';
import styles from './DashboardPage.module.css';
import {
  useInspectionCountByStatus,
  useInspectionList,
  useInspectionListFilters,
} from '../../hooks';
import { OwnershipFilter, DashboardInspectionStatus } from '../../hooks/useInspectionList/types';

const CURRENCY = '$';
const OWNERSHIP = OwnershipFilter.ORGANIZATION_RESOURCES;

export function DashboardPage() {
  const [triggerEffect, setTriggerEffect] = useState(false);
  const [isDrawerOpen, setDrawerIsOpen] = useState(true);
  const [view, setView] = useState(DashboardView.INSPECTION_LIST);
  const [status, setStatus] = useState<DashboardInspectionStatus | null>(null);
  const { filters, filterByDate, filterBySearchInput, filterByStatuses, toggleSortBy } =
    useInspectionListFilters();
  const { counts, loading: countsLoading } = useInspectionCountByStatus({
    status,
    ownershipFilter: OWNERSHIP,
    triggerEffect,
  });
  const {
    inspections,
    itemsLoading,
    totalLoading,
    pagination,
    setRowsPerPage,
    goToPreviousPage,
    goToNextPage,
    handleStatusChange,
  } = useInspectionList({
    ...filters,
    counts,
    triggerEffect,
    ownershipFilter: OWNERSHIP,
    setTriggerEffect,
  });

  const toggleOpenDrawer = () => setDrawerIsOpen((value) => !value);

  const selectStatus = (value: DashboardInspectionStatus | null) => {
    filterByStatuses(value ? [value] : null);
    setStatus(value);
    setView(DashboardView.INSPECTION_LIST);
  };

  return (
    <NavbarPage>
      <div className={styles['container']}>
        <DashboardDrawer
          isOpen={isDrawerOpen}
          onToggleOpen={toggleOpenDrawer}
          view={view}
          onClickInspectionLinkSend={() => setView(DashboardView.INSPECTION_LINK_CREATE)}
          status={status}
          onClickStatus={selectStatus}
          counts={counts}
          loading={countsLoading}
        />
        <div className={clsx(styles['drawerOffset'], isDrawerOpen && styles['openDrawer'])}>
          <div className={styles['pageContainer']}>
            {view === DashboardView.INSPECTION_LIST && (
              <InspectionListView
                filters={filters}
                toggleSortBy={toggleSortBy}
                inspections={inspections}
                itemsLoading={itemsLoading}
                totalLoading={totalLoading}
                showStatusColumn={status === null}
                pagination={pagination}
                setRowsPerPage={setRowsPerPage}
                goToPreviousPage={goToPreviousPage}
                goToNextPage={goToNextPage}
                currency={CURRENCY}
                filterByDate={filterByDate}
                filterBySearchInput={filterBySearchInput}
                filterByStatuses={filterByStatuses}
                status={status}
                onStatusChange={handleStatusChange}
              />
            )}
            {view === DashboardView.INSPECTION_LINK_CREATE && <InspectionLinkCreateView />}
          </div>
        </div>
      </div>
    </NavbarPage>
  );
}
